<template>
  <svg width="23" height="22" viewBox="0 0 43 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 31H22M22 31H6L2 19H18L22 31Z" stroke="currentColor" stroke-width="2" />
    <path
      d="M37 8C37 11.866 33.866 15 30 15C26.134 15 23 11.866 23 8C23 4.134 26.134 1 30 1C33.866 1 37 4.134 37 8Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M34 31H42V23.6946C38.363 21.9668 34.2944 21 30 21C27.9406 21 25.933 21.2224 24 21.6444"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
